import { router } from '@core/components/Router';
import ScrollToTop from '@core/components/ScrollToTop';
import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';

import NotFound from '../pages/NotFound';

const AppRoutes: FC = () => (
  <>
    <ScrollToTop />
    <Routes>
      {router.getRoutes().map(({ element, name, path }) => (
        <Route element={element} key={name} path={path} />
      ))}
      <Route element={<NotFound />} path='*' />
    </Routes>
  </>
);

export default AppRoutes;
